module.exports = __webpack_public_path__ + "static/media/jcb.a36e598d.svg";